var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import * as React from "react";
import { connect } from "react-redux";
import { IdStyles } from "../../less/IdStyles";
import { selectPlayerRemainingProbationTime } from "../../selectors/selectPlayerInfo";
import { FontWithOutline } from "../generic/font-with-outline/FontWithOutline";
import { TextLoca } from "../generic/text/TextLoca";
import { TimerCountdown } from "../generic/timer/TimerCountdown";
var _ProbationTimeOverlay = function (_a) {
    var remainingTime = _a.remainingTime, children = _a.children, idLoca = _a.idLoca;
    if (remainingTime <= 0) {
        return React.createElement(React.Fragment, null, children);
    }
    return (React.createElement("div", { className: "coop-overlay__container" },
        React.createElement("div", { className: IdStyles.BlackOverlay + " coop-overlay__item flex flex--guts flex--stacked" },
            React.createElement(TextLoca, { id: idLoca, className: IdStyles.TextBoldSecondaryOutline }),
            React.createElement(FontWithOutline, { style: IdStyles.TextBoldSecondaryOutline },
                React.createElement(TimerCountdown, { remainingTime: remainingTime }))),
        children));
};
var mapState = function (state, ownProps) { return (__assign({ remainingTime: selectPlayerRemainingProbationTime(state) }, ownProps)); };
export var ProbationTimeOverlay = connect(mapState)(_ProbationTimeOverlay);



//////////////////
// WEBPACK FOOTER
// ./src/features/cooperative/ProbationTimeOverlay.tsx
// module id = 599
// module chunks = 3